/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Side menu item styled
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';
import { ISideMenuItem } from '../SideMenuItem';

type TSideMenuItemStyled = Pick<ISideMenuItem, 'isActive' | 'isOpen'>;

export const SideMenuItemStyled = styled.div.attrs(({ isActive, isOpen }: TSideMenuItemStyled) => ({
    className: `side-menu__item${isActive ? ' side-menu__item_active' : ''}${isOpen ? ' side-menu__item_open' : ''}`,
}))<TSideMenuItemStyled>`
    position: relative;

    display: flex;
    justify-content: space-between;

    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid ${colors.borderColorDisabled};
    padding: 12px 20px;
    cursor: pointer;
    user-select: none;

    .side-menu__item-icon {
        transition: transform 200ms linear;
    }

    &.side-menu__item_active {
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            border-left: 1px solid ${colors.borderColorSuccess};
        }
        .text-block {
            ${fonts.textMainBold}
        }
    }

    .text-block {
        ${fonts.textMain}
    }

    &.side-menu__item_open {
        .side-menu__item-icon {
            transform: rotate(180deg);
        }
    }
`;

export const SideMenuItemChildrenStyled = styled.div.attrs({
    className: 'side-menu__item-children',
})<{ level: number }>`
    & .text-block {
        padding-left: ${props => props.level * 12}px;
    }
`
